import { forwardRef, type ChangeEvent } from 'react'

import { AUDIO_FILE_ACCEPT } from '@core/models'

type TReplaceSourceInputProps = {
    onSelectFile: (file: File) => void
    testID?: string
}

/**
 * Hidden picker for replacing an audio's source file. Must stay mounted outside the menu/sheet that
 * triggers it — those unmount their content on close, which would kill the pending `change` event.
 */
export const ReplaceSourceInput = forwardRef<HTMLInputElement, TReplaceSourceInputProps>(
    ({ onSelectFile, testID }, ref) => {
        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
            const input = event.currentTarget
            const file = input.files?.[0]

            // Reset so re-picking the same file still fires `change`.
            input.value = ''

            if (file) {
                onSelectFile(file)
            }
        }

        return (
            <input
                ref={ref}
                hidden
                type="file"
                accept={AUDIO_FILE_ACCEPT}
                onChange={handleChange}
                data-test={testID}
            />
        )
    },
)
